import { frappeList, frappeGet, frappeMethod } from "./utils";
import { getERPClient } from "./client";
import type { SalesOrder } from "./types/order";

export const orders = {
  /**
   * List all sales orders
   */
  list(filters?: Record<string, any>): Promise<SalesOrder[]> {
    return frappeList<SalesOrder>("Sales Order", filters, [
      "name", "customer", "customer_name", "transaction_date",
      "delivery_date", "status", "grand_total", "currency",
      "creation", "modified", "source_channel",
      "shopee_order_sn", "shopee_order_status",
      "lazada_order_status",
      "custom_storefront_source",
    ]);
  },

  /**
   * Get a single sales order by name
   */
  detail(orderName: string): Promise<SalesOrder> {
    return frappeGet<SalesOrder>("Sales Order", orderName);
  },

  /**
   * Create a new sales order
   */
  create(data: Record<string, any>): Promise<SalesOrder> {
    const client = getERPClient();
    return client.create({ doctype: "Sales Order", data });
  },

  /**
   * Update an existing sales order
   */
  update(name: string, data: Record<string, any>): Promise<SalesOrder> {
    const client = getERPClient();
    return client.update({ doctype: "Sales Order", name, data });
  },

  /**
   * Delete a sales order
   */
  delete(name: string): Promise<void> {
    const client = getERPClient();
    return client.delete({ doctype: "Sales Order", name });
  },

  /**
   * Export personalization data as CSV.
   * Returns { filename, content } — content is raw CSV string.
   */
  exportPersonalizationCSV(
    salesOrder?: string,
    salesOrders?: string[],
    dateFrom?: string,
    dateTo?: string,
    sourceChannels?: string[],
    paymentStatus?: string[],
    storefrontSources?: string[],
  ): Promise<{ filename: string; content: string }> {
    const params: Record<string, unknown> = {};
    if (salesOrders?.length) {
      params.sales_orders = JSON.stringify(salesOrders);
    } else if (salesOrder) {
      params.sales_order = salesOrder;
    }
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    if (sourceChannels?.length) params.source_channels = JSON.stringify(sourceChannels);
    if (paymentStatus?.length) params.payment_status = JSON.stringify(paymentStatus);
    if (storefrontSources?.length) params.storefront_sources = JSON.stringify(storefrontSources);
    return frappeMethod<{ filename: string; content: string }>(
      "zaviago_backend.storefront.personalization_export.export_personalization_csv",
      Object.keys(params).length ? params : undefined,
    );
  },
};

